import React from "react";
import { connect } from "formik";
import VSTextInput from "./VSTextInput";

const TextInput = connect(({ formik, name, value, ...props }) =>
  !value ? (
    <VSTextInput
      id={name}
      name={name}
      onChange={({ target: { value: newValue } }) =>
        formik.setFieldValue(name, newValue)
      }
      data-ga={name}
      {...props}
    />
  ) : (
    <input type="hidden" />
  )
);

export default TextInput;
